import React, { useEffect,useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode'; 
import './LoginScreen.css';

const LoginScreen = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the token is already in the cookies
    const token = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
    if (token) {
      const decodedToken = jwtDecode(token.split('=')[1]); // Decode the token
      if (decodedToken.role === 'ADMIN') {
        navigate('/admin-home'); // Redirect to admin home if role is ADMIN
      } else if (decodedToken.role === 'BRANCH') {
        navigate('/branch-home'); // Redirect to branch home if role is BRANCH
      }
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://kartikenterprisesindia.co.in/api/users/login', { username, password });
      const { role } = response.data;

      document.cookie = `auth_token=${response.data.token};path=/;max-age=${7 * 24 * 60 * 60}`;

      if (role === 'ADMIN') {
        navigate('/admin-home');
      } else if (role === 'HUB-HEAD') {
        navigate('/branch-home');
      } else if (role === 'BRANCH-INCHARGE') {
        navigate('/branch-home');
      } else if (role === 'STAFF') {
        navigate('/branch-home');
      } else if (role === 'DRIVER') {
        navigate('/branch-home');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="login-container" style={{color:'black'}}>
      <div className="login-card">
        <h2>Welcome to <span className="highlight">DSH</span></h2>
        <form onSubmit={handleLogin}>
          <div className="input-container">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-container">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
